/** @format */
import React, { useState } from "react";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslation } from "react-i18next";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const DocStat = ({ lots }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const toggleCollapse = () => setIsCollapsed(!isCollapsed);
  const { t } = useTranslation();

  const statusCounts = lots.reduce((acc, lot) => {
    const status = lot.Status;
    acc[status] = (acc[status] || 0) + 1;
    return acc;
  }, {});

  const chartData = {
    labels: Object.keys(statusCounts),
    datasets: [
      {
        label: t("Document"),
        data: Object.values(statusCounts),
        backgroundColor: [
          "rgba(255, 99, 132, 0.8)",
          "rgba(54, 162, 235, 0.8)",
          "rgba(75, 192, 192, 0.8)",
          "rgba(255, 206, 86, 0.8)",
          "rgba(153, 102, 255, 0.8)",
          "rgba(255, 159, 64, 0.8)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    plugins: {
      legend: { position: "top" },
      tooltip: { enabled: true },
    },
    scales: {
      x: { beginAtZero: true, ticks: { stepSize: 1 } },
    },
  };

 
  const stats = lots.reduce(
    (acc, lot) => {
      acc.totalDocs++;
      switch (lot.Status) {
        case "extracting":
          acc.inProgress++;
          break;
        case "waiting_review":
          acc.videoCoding++;
          break;
        case "completed":
          acc.completed++;
          break;
        case "exporting":
          acc.exporting++;
          break;
        case "error":
          acc.errors++;
          break;
        default:
          break;
      }
      return acc;
    },
    { totalDocs: 0, videoCoding: 0, completed: 0, exporting: 0, errors: 0 }
  );

  
  const cardsData = [
    { label: `${t("Total")} ${t("Documents")}`, value: stats.totalDocs, border: "#0288d1" },
    { label: t("Videocodage"), value: stats.videoCoding, border: "#7b1fa2" },
    { label: t("Completed") , value: stats.completed, border: "#2e7d32" },
    { label: `${t("Documents")}  ${t("Completed")} %`, value:
                  stats.totalDocs > 0
                    ? (
                        (stats.completed / stats.totalDocs) *
                        100
                      ).toFixed(1) + "%"
                    : "0%", border: "#f57c00" },
    { label: t("Exporting"), value: stats.exporting, border: "#c2185b" },
    { label: t("Doc in error"), value: stats.errors, border: "#d32f2f" },
  ];

  return (
    <div className="size-stats" style={{ width: "100%" }}>
      <div className="d-flex position_stats" onClick={toggleCollapse}>
        <div className="position_stats_arrow">
          <FontAwesomeIcon icon={isCollapsed ? faChevronDown : faChevronUp} />
        </div>
        <p style={{ fontWeight: "bold", fontSize: "18px", paddingTop: "10px" }}>
          {t("Statistics")}
        </p>
      </div>

      {!isCollapsed && (
        <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", marginTop: "15px", marginBottom: "15px" }}>
          {/* Bar chart horizontal */}
          <div
            className="chart-card"
            style={{
              flex: "0 0 40%",
              minWidth: "300px",
              padding: "15px",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              background: "#fff",
            }}
          >
            <Bar data={chartData} options={options} />
          </div>

          {/* Cards 6 cases */}
            <div
            className="cards-wrapper"
              style={{
              flex: "1",
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)", 
              gridTemplateRows: "repeat(2, 1fr)",
              gap: "8px",
            }}
          >
            {cardsData.map((card, i) => (
              <div
                key={i}
                style={{
                  background: "#fff",
                  padding: "10px",
                borderRadius: "10px",
                  border: "1px solid #e0e0e0",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                  textAlign: "center",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "70px", 
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
                  e.currentTarget.style.border = `1px solid ${card.border}`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.08)";
                  e.currentTarget.style.border = "1px solid #e0e0e0";
                }}
              >
                <p style={{ margin: 0, fontSize: "0.7rem", fontWeight: 500, color: "#555", textTransform: "uppercase" }}>
                  {card.label}
                </p>
                <h3 style={{ margin: "4px 0 0", fontSize: "1rem", fontWeight: 700, color: "#222" }}>
                  {card.value}
                </h3>
            </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DocStat;
